import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import ItemList from 'flarum/common/utils/ItemList';
import PollForm from './Poll/PollForm';
import PollFormState from '../states/PollFormState';
import ComposeHero from './ComposeHero';
import PollsIndexSidebar from './PollsIndexSidebar';
export default class ComposePollPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "poll", null);
    _defineProperty(this, "loading", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('globalPollsEnabled') || !app.forum.attribute('canStartGlobalPolls')) {
      m.route.set('/');
      return;
    }
    this.bodyClass = 'App--compose-poll';
    const editId = m.route.param('id');
    const pollPromise = editId ? this.loadEditingPoll(editId) : Promise.resolve(PollFormState.createNewPoll());
    pollPromise.then(poll => {
      var _this$poll;
      this.poll = poll;
      if (poll != null && poll.exists && !poll.canEdit()) {
        m.route.set('/');
        return;
      }
      const titleKey = "fof-polls.forum.compose.".concat((_this$poll = this.poll) != null && _this$poll.id() ? 'edit' : 'add', "_title");
      app.history.push('compose-poll', app.translator.trans(titleKey));
      app.setTitle(app.translator.trans(titleKey));
      app.current.set('poll', poll);
      m.redraw();
    });
  }
  async loadEditingPoll(editId) {
    const cached = app.store.getById('polls', editId);
    if (cached) return cached;
    this.loading = true;
    const poll = await app.store.find('polls', editId);
    this.loading = false;
    return poll;
  }
  view() {
    return m(PageStructure, {
      className: "ComposePollPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: this.loading || !this.poll
    }, this.contentItems().toArray());
  }
  hero() {
    if (!this.poll) return null;
    return m(ComposeHero, {
      item: this.poll,
      className: "ComposePollHero",
      translationPrefix: "fof-polls.forum.compose",
      managerRoute: "fof.polls.list",
      managerIcon: "far fa-edit",
      managerLabel: app.translator.trans('fof-polls.forum.compose.polls_manager'),
      viewRoute: "fof.polls.view",
      viewIcon: "far fa-arrow-up-right-from-square",
      viewLabel: app.translator.trans('fof-polls.forum.compose.polls_preview')
    });
  }
  sidebar() {
    return m(PollsIndexSidebar, null);
  }
  contentItems() {
    const items = new ItemList();
    if (this.poll) {
      items.add('form', m(PollForm, {
        poll: this.poll,
        onsubmit: this.onsubmit.bind(this),
        allowDrafts: true
      }));
    }
    return items;
  }
  async onsubmit(data, state) {
    await state.save(data);
    this.poll = state.poll;

    // Per-flow success alerts and navigation are owned by the caller
    // (save draft / publish / schedule / plain save). This handler only
    // persists and keeps the page bound to the latest saved model.
  }
}
flarum.reg.add('fof-polls', 'forum/components/ComposePollPage', ComposePollPage);